import Img from './img.element.js';

export default Img;

Img.define('wje-img', Img);
